/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Addmemberplaceholder2Inputs */

const en_cases_settings_category_addmemberplaceholder2 = /** @type {(inputs: Cases_Settings_Category_Addmemberplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select case managers`)
};

/**
* | output |
* | --- |
* | "Select case managers" |
*
* @param {Cases_Settings_Category_Addmemberplaceholder2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_addmemberplaceholder2 = /** @type {((inputs?: Cases_Settings_Category_Addmemberplaceholder2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Addmemberplaceholder2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_addmemberplaceholder2(inputs)
});
export { cases_settings_category_addmemberplaceholder2 as "cases_settings_category_addMemberPlaceholder" }